<footer class="footer ">
    <div class="container-fluid">       
        <div class="copyright">
            &copy;
            {{copyRightDate | date: 'yyyy'}}, 
            <a href="https://albert-ing.com/" target="_blank">albert.ing GmbH</a>
        </div>
    </div>
</footer>
